// extracted by mini-css-extract-plugin
module.exports = {"recruitAFriendContainer":"recruitafriend_recruitAFriendContainer__jB5gk","currentProfile":"recruitafriend_currentProfile__pacrv","recruitLink":"recruitafriend_recruitLink__lHYs5"};